<template>
    <el-container>
        <el-header><h1 style="font-weight: bold;font-size: 20px;border-bottom: 1px solid #ccc;padding: 18px 20px;">Distribution of transcription factors during development</h1></el-header>
        <el-container>
            <el-aside style="display: flex;justify-content: center;">
                <div class="tfbs-counter">
                    <div class="circle">Total:{{ tfbsCount }}</div>
                </div>
            </el-aside>
            <el-main>
                <div class="chart-container">
                    <div id="word3" style="width:100%;height:300px;"></div>
                </div>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
import "echarts-wordcloud";
export default {
    props: {
        species: {
            type: String,
            required: true
        },
        tissue: {
            type: [String, Array],
            required: true
        }
    },
    data() {
        return {
            tfbsCount: '',// TFBS数量初始值为0，可以根据实际情况进行修改
            chartData: [],
            url: "http://183.175.59.4/devenhancer/", // 后端接口地址
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        async getData() {
            try {
                const params = {
                    Species: this.species,
                    Tissue: this.tissue
                };
                const response = await this.$axios.get(this.url + "tfbsgene" + "/", { params });
                const data = response.data;
                // 计算非重复的 Tfbs 数量
                const uniqueTfbsCount = new Set(data.filter(item => item.Tfbs !== "").map(item => item.Tfbs)).size;
                this.tfbsCount = uniqueTfbsCount;
                // 提取 Tfbs 列数据
                const uniqueTfbsSet = new Set(data.filter(item => item.Tfbs !== "").map(item => item.Tfbs));
                this.chartData = Array.from(uniqueTfbsSet).map(tfbs => ({ name: tfbs, value: 1 })); // 设置一个默认的 value

                this.renderChart();
            } catch (error) {
                console.error(error);
            }
        },
        renderChart() {
            const chart = this.$echarts.init(document.getElementById("word3"));
            const colorList = ["#ff7f50", "#87cefa", "#da70d6", "#32cd32", "#6495ed"];
            // visualMap 使得词云颜色丰富
            const visualMap = {
                type: "piecewise",
                min: 0,
                max: this.chartData.length - 1,
                splitNumber: colorList.length,
                dimension: 0,
                orient: "horizontal",
                top: "bottom",
                left: "center",
                textStyle: {
                    color: "#333"
                },
                pieces: colorList.map((color, index) => {
                    const step = Math.ceil(this.chartData.length / colorList.length);
                    return {
                        gt: index * step,
                        lte: (index + 1) * step - 1,
                        color: color
                    };
                }),
                show: false
            };
            const option = {
                series: [
                    {
                        type: "wordCloud",
                        gridSize: 10,
                        sizeRange: [12, 50],
                        rotationRange: [-90, 90],
                        shape: "circle",
                        textStyle: {
                            normal: {
                                fontFamily: 'sans-serif',
                                fontWeight: '700',
                            },
                        },
                        data: this.chartData.map((item, index) => {
                            return {
                                name: item.name.toUpperCase(),
                                value: item.value,
                                textStyle: {
                                    color: this.calculateColor(index, visualMap.pieces)
                                }
                            };
                        })
                    }
                ],
                visualMap: visualMap
            };
            chart.setOption(option);
        },

        calculateColor(index, pieces) {
            const matchingPiece = pieces.find(piece => index >= piece.gt && index <= piece.lte);
            return matchingPiece ? matchingPiece.color : "#000"; // 默认颜色，可以根据需要更改
        },
    },
};
</script>

<style scoped>
.tfbs-counter {
    display: flex;
    justify-content: center;
    align-items: center;
}

.circle {
    width: 200px;
    height: 200px;
    border-radius: 50%;
    background-color: #2D9596;
    color: #fff;
    font-size: 24px;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
}
.chart-container {
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1); /* 添加阴影效果 */
}
</style>



// WEBPACK FOOTER //
// src/components/home/Tffig2.vue